import {get, post, uploadFiles} from './request';
import store from '@/vuex/store'


// 恢复管理员删除状态
export function userRoleBackupRestore(data) {
  return post('user/role/backup/restore', data)
}

// 根据手机号查询角色
export function backupQueryAdminUser (tel) {
  return post('user/role/backup/queryAdminUser', {tel})
}

// 添加角色
export function backUserRoleBackupAdd(data) {
  return post('user/role/backup/add', data)
}


/**
 * 获取数据统计首页统计数据(包含总稿件数量，单行业稿件数量，单行业数据数量)
 * @param industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @returns {Promise<[*,*]>}
 */
export function getDataCount(industryType) {
  return post('bid/dataStatistics/back/getDataCount', {industryType})
}

/**
 * 获取操作记录列表
 * @param data
 * @param data.pageNum 页码
 * @param data.pageSize 显示数
 * @param data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param data.startTime 开始时间
 * @param data.endTime 结束时间
 * @returns {Promise<[*,*]>}
 */
export function getOperateRecord(data) {
  return post('bid/dataStatistics/back/getOperateRecord', data)
}

/**
 * 获取文章列表接口
 * @param {*} data
 * @param data.pageNum 页码
 * @param data.pageSize 显示数
 * @param data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param data.searchTitle 搜索标题
 * @param data.startTime 开始时间
 * @param data.endTime 结束时间
 * @param data.createUser 创建人昵称
 * @param data.timeType 统计周期 1月度2季度3半年4年度
 * @param data.sortType 排序  1倒叙2正序
 * @returns {Promise<[*,*]>}
 */
export function getStatisticsArticleList(data) {
  return post('bid/dataStatistics/back/getArticleList', data)
}

/**
 * 获取文章排名
 * @param {*} data
 * @param {*} data.pageNum 页码
 * @param {*} data.pageSize 显示数
 * @param {*} data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param {*} data.startTime 开始时间
 * @param {*} data.endTime 结束时间
 * @param {*} data.sortType 1倒叙2正序
 * @returns
 */
export function getArticleRanking(data) {
  return post('bid/dataStatistics/back/getArticleRanking', data)
}

/**
 * 获取行业数据列表
 * @param {*} data
 * @param {*} data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param {*} data.pageNum 页码
 * @param {*} data.pageSize 显示数
 * @param {*} data.searchTitle 搜索标题
 * @param {*} data.titleType 标题类型(1项目名称2中标供应商3代理机构)
 * @param {*} data.startTime 开始时间
 * @param {*} data.endTime 结束时间
 * @param {*} data.searchMoney 搜索金额
 * @param {*} data.moneyType 金额类型(1以上2以下)
 * @param {*} data.searchProvince 搜索省份 regionCode
 * @param {*} data.sortType 排序方式(1公告日期正序2公告日期倒叙3金额正序4金额倒叙)
 * @param {*} data.searchElevatorCategoryId 采购类别筛选项ID
 * @param {*} data.purchaserCategoryType (1电梯行业市场划分2电梯行业维保划分3点题行业更新改造划分4点题行业加装电梯划分)（外层列表无该参数）
 * @param {*} data.purchaserCategoryTypeId purchaserCategoryType的子项ID，如果是全部则为null
 * @returns
 */
export function getDataList(data) {
  return post('bid/dataStatistics/back/getDataList', data)
}

/**
 * 获取电梯采购类别筛选项(全部子集)
 * @param {*} industryType 行业类型
 * @returns
 */
export function getPurchaserCategoryDictionary(industryType) {
  return post('bid/dataStatistics/back/getPurchaserCategoryDictionary', {industryType})
}

/**
 * 获取电梯采购类别筛选项(细分市场/功能划分)
 * @param dictionaryType 1细分市场2功能划分
 * @returns {Promise<[*,*]>}
 */
export function getFunctionalPartitioningDictionary(dictionaryType) {
  return post('bid/dataStatistics/back/getFunctionalPartitioningDictionary', {dictionaryType})
}

/**
 * 获取行业筛选项三级
 * @param dictionaryType 1细分市场2功能划分3车型4车辆用途5空调产品类型6家具细分市场7服务器细分市场8视频会议细分市场9体育市场采购细分10政府机关采购细分
 *
 */
export function getPartitioningChild(dictionaryType) {
  return post('bid/dataStatistics/back/getFunctionalPartitioningDictionaryChild', {dictionaryType})
}

/**
 * 搜索地区
 * @returns
 * @param data
 * @param data.searchTitle 搜索内容
 * @param data.regionLevel 1：只搜索省份
 */
export function queryCity(data) {
  return post('dataStatistics/getCity', data)
}

/**
 * 下载行业模板
 * @param {*} industryType 行业类型
 * @returns
 */
export function downloadIndustryExcel(industryType) {
  return post('bid/dataStatistics/back/downloadIndustryExcel', {industryType}, {
    responseType: 'blob',
    timeout: 60000 * 3
  })
}


/**
 * 导入清洗后的数据
 * @param {*} data
 * @param {*} data.industryType 行业类型
 * @param {*} data.file 上传的file文件
 * @returns
 */
export function importData(data) {
  return uploadFiles('bid/dataStatistics/back/importData', data)
}

/**
 * 获取已上传的文件列表
 * @param {*} data
 * @param {*} data.industryType 所属行业
 * @param {*} data.pageNum 页码
 * @param {*} data.pageSize 显示数
 * @param {*} data.startTime 开始时间
 * @param {*} data.endTime 结束时间
 * @param {*} data.createUser 创建人昵称
 * @returns
 */
export function loadImportData(data) {
  return post('bid/dataStatistics/back/loadImportData', data)
}

/**
 * 撤回导入的数据
 * @param {*} fileId 撤回的文件ID
 * @returns
 */
export function recallImportData(fileId) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/recallImportData', {fileId, industryType})
}

/**
 * 获取下载表格链接
 * @param {*} fileId 文件ID
 * @returns
 */
export function downloadImportData(fileId) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/downloadImportData', {fileId, industryType})
}

/**
 * 导出数据
 * @param {*} data
 * @param {*} data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param {*} data.searchTitle 搜索标题
 * @param {*} data.titleType 标题类型(1项目名称2中标供应商3代理机构)
 * @param {*} data.startTime 开始时间
 * @param {*} data.endTime 结束时间
 * @param {*} data.searchMoney 搜索金额
 * @param {*} data.moneyType 金额类型(1以上2以下)
 * @param {*} data.searchProvince 搜索省份(字符串)
 * @param {*} data.sortType 排序方式(1公告日期正序2公告日期倒叙3金额正序4金额倒叙)
 * @param {*} data.searchElevatorCategoryId 采购类别筛选项ID
 * @param {*} data.purchaserCategoryType (1电梯行业市场划分2电梯行业维保划分3点题行业更新改造划分4点题行业加装电梯划分)（外层列表无该参数）
 * @param {*} data.purchaserCategoryTypeId purchaserCategoryType的子项ID，如果是全部则为null
 * @returns
 */
export function exportInformation(data) {
  return post('bid/dataStatistics/back/exportInformation', data, {responseType: 'blob', timeout: 60000 * 3})
}

/**
 * 获取每个行业核验字段筛选项
 * @param industryType
 * @returns {Promise<[*,*]>}
 */
export function getIndustryVerifyConfig(industryType) {
  return post('bid/dataStatistics/back/getIndustryVerifyConfig', {industryType})
}

/**
 * 更新清洗后的数据列表
 * @param {*} data
 * @param {*} data.id 数据ID
 * @param {*} data.projectDate 公告日期（后面时分秒是固定的，我测试时不加时分秒格式无法自动转换）
 * @param {*} data.projectRegionProvince 省(字典编号)
 * @param {*} data.projectRegionCity 市(字典编号)
 * @param {*} data.projectName 项目名称
 * @param {*} data.projectMoney 金额(单位分)
 * @param {*} data.projectWinningBidder 中标供应商
 * @param {*} data.projectAgency 代理机构
 * @param {*} data.projectPurchaserType 采购类别(字典编号)
 * @returns
 */
export function updateIndustryData(data) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/updateData', {bidDataInformation: data, industryType})
}

/**
 * 删除清洗后的数据列表
 * @param {Array} idList
 * @returns
 */
export function deleteIndustryData(idList) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/deleteData', {idList, industryType})
}

/**
 * 批量操作清洗后的数据列表
 * @param data 列表，要修改的item，{ id: 1, projectDate: '', projectName: '', ... } 需要修改什么就穿什么字段
 * @returns {Promise<[*,*]>}
 */
export function batchUpdateDataList(data) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/updateDataList', {bidDataInformationList: data, industryType})
}

/**
 * 获取图表数据头部总数
 * @param data 跟获取图表数据接口参数一样
 * @returns {Promise<[*,*]>}
 */
export function getHeaderCount(data) {
  return post('bid/dataStatistics/back/getHeader', data)
}

/**
 * 获取图表数据
 * @param data
 * @param data.industryType 行业类型(null 全部;1电梯;2家具;3汽车;4物业;5照明;6空调;7服务器;8视频会议;9体育;10医疗)
 * @param data.startTime 开始时间
 * @param data.endTime 结束时间
 * @param data.searchProvince 搜索省份(字符串)
 * @param data.searchMoney 搜索金额
 * @param data.moneyType 金额类型(1以上2以下)
 * @param data.purchaserCategoryType (1电梯行业市场划分2电梯行业维保划分3点题行业更新改造划分4点题行业加装电梯划分)
 * @param data.purchaserCategoryTypeId purchaserCategoryType的子项ID，如果是全部则为null
 * @param data.queryScope 1、地图(公用)2、折线图(公用)3、细分市场(公用)4、采购列表(电梯)5、车型(汽车)
 * @param data.comparisonType 折线图同比/环比开启方式(0不开启1开启同比2开启环比)
 * @param data.timeType 0自定义(不获取环比数据)1月份2季度3年份(不获取环比数据)
 * @param data.sortType 1金额排序2数量排序（折线图模式只按照日期正序排列）
 * @returns {Promise<[*,*]>}
 */
export function getChart(data) {
  return post('bid/dataStatistics/back/getChart', data)
}


// 保存文章
export function insertArticle(article) {
  let url = 'bid/dataStatistics/back/insertArticle'
  if (article.articleId) {
    url = 'bid/dataStatistics/back/updateArticle'
  }
  let industryType = store.state.industry.dataForm.industryType
  return post(url, {article, industryType})
}

// 获取文章
export function getArticle(articleId) {
  return post('bid/dataStatistics/back/getArticle', {articleId})
}

// 删除文章
export function deleteArticle(articleId) {
  let industryType = store.state.industry.dataForm.industryType
  return post('bid/dataStatistics/back/deleteArticle', {articleId, industryType})
}

/**  获取采购方式 */
export function getPurchase() {
  return get('/dic/purchase', {})
}

/**  获取采购人类型(细分市场) */
export function getPurchaser() {
  return get('/dic/purchaser', {})
}

/**  获取筛选项 ,全部 */
export function getConditionVos() {
  return post('/dic/condition/vos', {})
}

// 订单退款
export function orderRefund(orderId, userId) {
  return post('/deal/order/refund', {orderId, userId})
}
